import { render, staticRenderFns } from "./tabFundApply.vue?vue&type=template&id=5606f46c&"
import script from "./tabFundApply.vue?vue&type=script&lang=ts&"
export * from "./tabFundApply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports